module.exports = require('./_hide');



// WEBPACK FOOTER //
// ./node_modules/core-js/library/modules/_redefine.js